import React, { useState } from "react";
import { FormControl, Paper, ThemeProvider } from "@mui/material";
import theme from "../../mui-theme";
import IconButton from "@mui/material/IconButton";
import { RiSearchLine } from "react-icons/ri";
import InputBase from "@mui/material/InputBase";

type SEInputSearchProps = {
    value?:string | null | undefined
    placeholder?: string;
    onClick: (value?: string | null | undefined) => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const SEInputSearch: React.FC<SEInputSearchProps> = ({
                                                                value= null ,
                                                                onClick,
                                                                placeholder = "Digite o que você procura",
                                                            }) => {
    const [inputValue, setInputValue] = useState<string | null>(value);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onClick(inputValue);
        }
    };

    return (
        <FormControl fullWidth>
            <ThemeProvider theme={theme}>
                <Paper sx={{ display: "flex", alignItems: "center", px: 1 }}>
                    <InputBase
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        sx={{ flex: 1 }}
                        placeholder={placeholder}
                        inputProps={{ "aria-label": placeholder }}
                    />
                    <IconButton
                        onClick={() => onClick(inputValue)}
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                    >
                        <RiSearchLine size={18} />
                    </IconButton>
                </Paper>
            </ThemeProvider>
        </FormControl>
    );
};

export default SEInputSearch;
